export const BILLING_EMAIL_LINK = "mailto:carrierbilling@ryantrans.com";
export const BILLING_EMAIL_LINK_TEXT = "carrierbilling@ryantrans.com ";
export const RATE_VERFICATION_SERVICE_URL: string = process.env
  .REACT_APP_RATE_VERFICATION_SERVICE_URL as string;
